const module = angular.module('ryModal', ['ngAnimate']);

module.config(['$compileProvider', function($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
}]);

module.component('ryModalComponent', {
    transclude: true,
    templateUrl: 'tpl/ry-modal.component.html',
    bindings: {
        isShown: '<',
        isLocked: '<',
        onConfirm: '&',
        onDismiss: '&',
        confirmText: '@',
        dismissText: '@',

        hideButtons: '<',

        isConfirmLocked: '<',
        isDismissLocked: '<'
    },
    controller: function($document) {
        this.$onInit = function() {
            $document.on('keydown', this.onKeyDown);

            if (!this.hideButtons) this.hideButtons = {};
            for (const btn of ['confirm', 'dismiss']) {
                if (angular.isUndefined(this.hideButtons[btn])) {
                    this.hideButtons[btn] = false;
                }
            }
        }

        this.$onDestroy = function() {
            $document.off('keydown', this.onKeyDown);
        }

        this.dismiss = function() {
            if (this.isLocked || this.isDismissLocked) return;
            this.onDismiss();
        };

        this.confirm = function() {
            if (this.isLocked || this.isConfirmLocked) return;
            this.onConfirm();
        };

        this.onClick = function(e) {
            if (this.isLocked || this.isDismissLocked) return;
            this.onDismiss();
        }

        this.onKeyDown = function(e) {
            if (this.isLocked || this.isDismissLocked) return;
            if (this.isShown && e.key === 'Escape') {
                this.onDismiss();
            }
        }
    }
});

module.component('ryConfigurableModalComponent', {
    transclude: true,
    templateUrl: 'tpl/ry-configurable-modal.component.html',
    bindings: {
        isShown: '<',
        buttonConfig: '<',
        dismissible: '<',
        onActivate: '&',
        locked: '<'
    },
    controller: function($document, $scope) {
        this.$onInit = function() {
            $scope.$watch('$ctrl.isShown', (isCurrentlyShown, wasShown) => {
                if (isCurrentlyShown) {
                    $document.on('keydown', this.onKeyDown);
                } else {
                    $document.off('keydown', this.onKeyDown);
                }
            });

            if (!angular.isDefined(this.buttonConfig)) {
                this.buttonConfig = [];

                this.buttonConfig.push({
                    id: 'confirm',
                    variant: 'btn-success',
                    disabled: false,
                    text: 'Bestätigen'
                });

                this.buttonConfig.push({
                    id: 'dismiss',
                    variant: 'btn-primary',
                    disabled: false,
                    text: 'Abbrechen'
                });
            }

            if (!angular.isDefined(this.dismissible)) {
                this.dismissible = true;
            }

            if (!angular.isDefined(this.locked)) {
                this.locked = false;
            }
        }

        this.$onDestroy = function() {
            $document.off('keydown', this.onKeyDown);
        }

        this.onClick = function(e) {
            if (!this.dismissible || this.locked) return;

            this.onActivate({response: 'dismiss'});
        }

        this.onKeyDown = (e) => {
            if (!this.dismissible || this.locked || !this.isShown) {
                return;
            }

            if (e.key === 'Escape') {
                this.onActivate({response: 'dismiss'});
                $scope.$apply();
            }
        }

        this.activate = function(type) {
            if (this.locked) return;

            this.onActivate({response: type});
        }
    }
});
